import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.688 10.5a5.812 5.812 0 1 1 11.624 0 5.812 5.812 0 0 1-11.625 0ZM10.5 2.812a7.687 7.687 0 1 0 4.733 13.746l4.354 4.355a.937.937 0 0 0 1.326-1.326l-4.355-4.354A7.687 7.687 0 0 0 10.5 2.813Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgSearch);

export default Memo;
